const state = {

    AttachmentFiles: [],
    SplittedNotamText : "",
};
const mutations = {
        set_AttachmentList_Flight(state,payload){
            if (payload.length) {
                state.AttachmentFiles = payload;
                state.samplevalue = "files";
            }
        },
    };

const actions = {

};

const getters = {

}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
}
